import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "24.267",
      height: "15.6",
      x: ".866",
      y: "5.933",
      stroke: "currentColor",
      "stroke-width": "1.5",
      rx: "1"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.866 11.933 4.6 15.667h16.8l3.733-3.734m-14 .934h3.733"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "M7.798 5.933V2.667a1 1 0 0 1 1-1h8.4a1 1 0 0 1 1 1v3.266"
    }, null, -1)
  ]))]))
}
export default { render: render }